/* Aroma Paradise semantic CRO observability layer.
 * Scope: native homepage, collection routes, and native CRO product templates.
 * GemPages layouts/nodes are explicitly excluded. No input values or PII.
 * Rev: ap-cro-observer-v14-marking-20261008
 */
(function () {
  'use strict';
  if (window.__APCROObserverInstalled) return;

  function isLikelyAutomation() {
    try {
      if (navigator.webdriver === true) return true;
      return /(bot|crawler|spider|headlesschrome|chrome-lighthouse|lighthouse|pagespeed|google-inspectiontool|puppeteer|playwright|phantomjs)/i.test(navigator.userAgent || '');
    } catch (_) { return false; }
  }
  if (isLikelyAutomation()) {
    window.__APCROObserverInstalled = true;
    return;
  }

  var VERSION = 'ap-cro-observer-v14-marking-20261008';
  var GA4_MEASUREMENT_ID = 'G-BWV3G4G3PQ';
  var GA4_EVENT_WHITELIST = {
    cro_section_viewed: 'section_view',
    cro_element_interacted: 'section_click'
  };
  var DIRECT_URL = 'https://analytics.aromaparadise.com/live/cro_event';
  var CRO_ROOTS = [
    ['[data-ap-waterless-diffuser-cro]', 'waterless-diffuser-cro'],
    ['[data-ap-df]', 'waterless-diffuser-cro'],
    ['[data-ap-hd]', 'humidifying-cro'],
    ['[data-ap-incense]', 'incense-cro'],
    ['[data-ap-ro]', 'regular-fragrance-cro'],
    ['[data-ap-cro]', 'waterless-fragrance-cro'],
    ['[data-ap-sand-pdp]', 'sand-candle-cro'],
    ['[data-ap-sand-v2].ap-unscented', 'unscented-sand-cro'],
    ['[data-ap-sand-v2]', 'sand-candle-v2-cro']
  ];
  var GP_SELECTOR = '[class*="gempages"],[class*="gp-section"],[class*="gp-global"],[id^="gp-"],[data-gp-section],gp-section';
  var INTERACTIVE_SELECTOR = [
    '[data-cro-element]', 'a[href]', 'button', 'summary', 'select',
    'input[type="radio"]', 'input[type="checkbox"]', 'input[type="range"]',
    'input[type="search"]', 'input[type="text"]', 'input[type="email"]',
    'input[type="tel"]', 'input[type="url"]', 'textarea', '[role="button"]',
    '[role="tab"]', '[role="option"]', '[role="slider"]', 'video'
  ].join(',');
  var MAX_TEXT = 72;
  var pageViewId = window.__ap_visit || makeId();
  var eventSequence = 0;
  var context = null;
  var sectionStates = [];
  var sectionByElement = typeof WeakMap === 'function' ? new WeakMap() : null;
  var observer = null;
  var mutationTimer = 0;
  var scrollTicking = false;
  var emittedPageView = false;
  var observedStructure = '';
  var focusedFields = typeof WeakSet === 'function' ? new WeakSet() : null;
  var pendingGa4Events = [];

  function makeId() {
    try { return crypto.randomUUID(); } catch (_) {}
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function clean(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80);
  }
  function safeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, MAX_TEXT);
  }
  function hash(value) {
    var h = 2166136261;
    for (var i = 0; i < value.length; i++) { h ^= value.charCodeAt(i); h = Math.imul(h, 16777619); }
    return (h >>> 0).toString(36);
  }
  function inGemPages(node) {
    if (!node || !node.closest) return false;
    return !!node.closest(GP_SELECTOR);
  }
  function identifyContext() {
    var path = location.pathname.replace(/\/$/, '') || '/';
    var home = document.querySelector('[data-ap-home-rebuild]');
    if (path === '/' && home && !inGemPages(home)) return { page_type: 'home', template_key: 'native-homepage', root: home };
    if (/^\/collections\//.test(path)) return { page_type: 'collection', template_key: 'native-collection', root: document.getElementById('MainContent') || document.body };
    if (/^\/products\//.test(path)) {
      for (var i = 0; i < CRO_ROOTS.length; i++) {
        var root = document.querySelector(CRO_ROOTS[i][0]);
        if (root && !inGemPages(root)) return {
          page_type: 'product', template_key: CRO_ROOTS[i][1], cro_root: root,
          root: document.getElementById('MainContent') || root
        };
      }
    }
    return null;
  }
  function eligible(){ return !!(window.apAnalyticsEligibility && window.apAnalyticsEligibility.current().eligible); }
  function eventPayload(props) {
    return Object.assign({
          cro_schema: 1,
          tracker_version: VERSION,
          page_view_id: pageViewId,
          page_path: location.pathname,
          page_type: context.page_type,
          template_key: context.template_key,
          page_revision: context.page_revision,
          device: innerWidth <= 767 ? 'mobile' : 'desktop'
        }, props || {}, window.apAnalyticsEligibility.properties());
  }
  function sendDirect(name, payload) {
    if (!eligible()) return;
    var packet = JSON.stringify({
      event_id: pageViewId + ':' + (++eventSequence) + ':' + name,
      visit_id: window.__ap_visit || pageViewId,
      visitor_uuid: window.__ap_visitor || '',
      name: name,
      ts: Date.now(),
      payload: payload
    });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(DIRECT_URL, new Blob([packet], { type: 'text/plain;charset=UTF-8' }))) return;
    } catch (_) {}
    var attempts = 0;
    function retry() {
      if (!eligible()) return;
      attempts++;
      if (typeof fetch !== 'function') return;
      fetch(DIRECT_URL, { method: 'POST', body: packet, keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' } })
        .then(function (response) { if (!response.ok && attempts < 4) setTimeout(retry, attempts * 500); })
        .catch(function () { if (attempts < 4) setTimeout(retry, attempts * 500); });
    }
    retry();
  }
  function productCardItem(node, payload) {
    if (!node || payload.interaction !== 'click' || !node.matches('a[href]')) return null;
    var path = '';
    try { path = new URL(node.getAttribute('href'), location.origin).pathname; } catch (_) { return null; }
    var match = path.match(/^\/products\/([^/?#]+)/);
    if (!match) return null;
    var card = node.closest('article,[data-product-card],[data-product-id],[data-handle],.card-wrapper');
    if (!card || inGemPages(card)) return null;
    var heading = card.querySelector('[data-product-title],h2,h3,.card__heading,.pcard__title');
    var item = {
      item_id: clean(decodeURIComponent(match[1])),
      item_name: safeText(
        node.getAttribute('aria-label') ||
        (heading && heading.textContent) ||
        node.textContent ||
        match[1]
      ),
      item_list_id: payload.section_id || 'unassigned',
      item_list_name: payload.section_label || payload.section_id || 'unassigned'
    };
    var rank = parseInt(card.getAttribute('data-rank') || '', 10);
    if (rank > 0) item.index = rank - 1;
    return item;
  }
  function ga4Params(payload) {
    return {
      send_to: GA4_MEASUREMENT_ID,
      section_id: payload.section_id || 'unassigned',
      section_label: payload.section_label || '',
      section_position: payload.section_position || 0,
      element_id: payload.element_id || '',
      element_role: payload.element_role || '',
      interaction: payload.interaction || 'view',
      page_type: payload.page_type || '',
      template_key: payload.template_key || '',
      device_type: payload.device || ''
    };
  }
  function sendGa4Event(eventName, params, item) {
    if (!eligible()) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('event', eventName, params);
      if (item) {
        window.gtag('event', 'select_item', Object.assign({}, params, {
          item_list_id: item.item_list_id,
          item_list_name: item.item_list_name,
          items: [item]
        }));
      }
    } catch (_) {}
  }
  function flushGa4Events() {
    if (!eligible()) { pendingGa4Events = []; return; }
    if (document.readyState !== 'complete' || document.visibilityState !== 'visible') return;
    var queued = pendingGa4Events.splice(0);
    queued.forEach(function (entry) { sendGa4Event(entry.eventName, entry.params, entry.item); });
  }
  function queueGa4Event(name, payload, node) {
    var eventName = GA4_EVENT_WHITELIST[name];
    if (!eventName) return;
    if (eventName === 'section_click' && !/^(click|open|close|play)$/.test(payload.interaction || '')) return;
    var entry = { eventName: eventName, params: ga4Params(payload), item: productCardItem(node, payload) };
    if (document.readyState !== 'complete' || document.visibilityState !== 'visible') {
      pendingGa4Events.push(entry);
      return;
    }
    sendGa4Event(entry.eventName, entry.params, entry.item);
  }
  function emit(name, props, node) {
    if (!eligible()) return;
    var payload = eventPayload(props);
    queueGa4Event(name, payload, node);
    sendDirect(name, payload);
    var attempts = 0;
    function sendReplayCopy() {
      if (!eligible()) return;
      if (typeof window.__APEvent === 'function') {
        try { window.__APEvent(name, payload); } catch (_) {}
      } else if (++attempts < 120) setTimeout(sendReplayCopy, 250);
    }
    sendReplayCopy();
  }
  function semanticClass(node) {
    var classes = String(node.className || '').split(/\s+/).filter(function (x) {
      return x && !/^is-|^active$|^animate|^color-|^gradient$/.test(x);
    });
    if (!classes.length) return '';
    var value = classes[0].replace(/^shopify-section-?/, '').replace(/^ap-[a-z0-9-]+__/, '').replace(/^apv?\d*-?/, '');
    return clean(value || classes[0]);
  }
  function sectionId(node, index) {
    var resolved = node.getAttribute('data-cro-resolved-section');
    if (resolved) return clean(resolved);
    var explicit = node.getAttribute('data-cro-section');
    if (explicit) return clean(explicit);
    var id = clean(node.id || '');
    if (id && !/^shopify-section-template-/.test(id)) return id.replace(/^shopify-section-/, '');
    var cls = semanticClass(node);
    if (cls && cls !== 'section') return cls;
    var heading = node.querySelector('h1,h2,h3,[aria-label]');
    var label = heading && (heading.getAttribute('aria-label') || heading.textContent);
    return clean(label) || ('section-' + (index + 1));
  }
  function discoverSections() {
    if (!context || !context.root) return [];
    var nodes = Array.prototype.slice.call(context.root.querySelectorAll('[data-cro-section],section,.shopify-section'));
    if (context.root.matches && context.root.matches('section,[data-cro-section]')) nodes.unshift(context.root);
    var seen = {};
    return nodes.filter(function (node, index) {
      if (!node || inGemPages(node) || node.closest('header,footer,nav') || node.hidden) return false;
      if (node.matches('.shopify-section') && node.querySelector('section,[data-cro-section]')) return false;
      var rect = node.getBoundingClientRect();
      if (rect.height < 80 || rect.width < 180) return false;
      var id = sectionId(node, index);
      if (!id) return false;
      if (seen[id]) {
        var heading = node.querySelector('h1,h2,h3,[aria-label]');
        var headingId = clean(heading && (heading.getAttribute('aria-label') || heading.textContent));
        id = id + '-' + (headingId || ('section-' + (index + 1)));
      }
      if (seen[id]) id = id + '-' + (index + 1);
      seen[id] = 1;
      node.setAttribute('data-cro-resolved-section', id);
      return true;
    });
  }
  function structureRevision(nodes) {
    var ids = nodes.map(function (n, i) { return sectionId(n, i); }).join('|');
    var themeId = window.Shopify && Shopify.theme && Shopify.theme.id ? String(Shopify.theme.id) : 'theme';
    return context.template_key + ':' + themeId + ':' + hash(ids);
  }
  function sectionFor(node) {
    var section = node && node.closest && node.closest('[data-cro-resolved-section]');
    return section ? section.getAttribute('data-cro-resolved-section') : 'unassigned';
  }
  function sectionLabel(node, fallbackId) {
    if (!node) return '';
    var explicit = node.getAttribute('data-cro-label');
    if (explicit) return safeText(explicit);
    var heading = node.querySelector('h1,h2,h3');
    if (heading && safeText(heading.textContent)) return safeText(heading.textContent);
    var aria = node.getAttribute('aria-label');
    if (aria) return safeText(aria);
    var known = {
      'hero': 'Product overview',
      'system': 'Diffuser compatibility',
      'decision': 'Scent profile',
      'uses': 'How to use this oil',
      'bundle': 'Multi-buy savings',
      'ap-ro-sizes': 'Size guide',
      'objections': 'Frequently asked questions',
      'ap-ro-reviews': 'Review summary',
      'ap-rvx': 'Customer review list'
    };
    return known[fallbackId] || '';
  }
  function sectionLabelFor(node) {
    var section = node && node.closest && node.closest('[data-cro-resolved-section]');
    var id = section ? section.getAttribute('data-cro-resolved-section') : 'unassigned';
    return sectionLabel(section, id);
  }
  function beginVisibility(state, ratio) {
    if (!eligible() || document.visibilityState !== 'visible') return;
    state.maxPct = Math.max(state.maxPct, Math.round(ratio * 100));
    if (!state.visibleSince) state.visibleSince = Date.now();
    if (!state.viewTimer && !state.viewed) {
      state.viewTimer = setTimeout(function () {
        state.viewTimer = 0;
        if (!eligible() || !state.visibleSince || state.viewed || document.visibilityState !== 'visible') return;
        state.viewed = true;
        emit('cro_section_viewed', {
          section_id: state.id, section_label: state.label, section_position: state.position,
          visible_ms: Date.now() - state.visibleSince, max_visible_pct: state.maxPct
        });
      }, 800);
    }
  }
  function markReached(state, source) {
    if (!state || state.reached) return;
    state.reached = true;
    emit('cro_section_reached', {
      section_id: state.id, section_label: state.label, section_position: state.position,
      reach_source: source || 'viewport'
    });
  }
  function markScrollDepth() {
    scrollTicking = false;
    if (!eligible() || document.visibilityState !== 'visible') return;
    var depth = scrollY + innerHeight * 0.85;
    sectionStates.forEach(function (state) {
      var top = state.node.getBoundingClientRect().top + scrollY;
      if (top <= depth) markReached(state, 'scroll_depth');
    });
  }
  function endVisibility(state) {
    if (state.viewTimer) { clearTimeout(state.viewTimer); state.viewTimer = 0; }
    if (!state.visibleSince) return;
    state.visibleMs += Date.now() - state.visibleSince;
    state.visibleSince = 0;
    if (state.viewed && !state.engaged && state.visibleMs >= 1500) {
      state.engaged = true;
      emit('cro_section_engaged', {
        section_id: state.id, section_label: state.label, section_position: state.position,
        visible_ms: state.visibleMs, max_visible_pct: state.maxPct
      });
    }
  }
  function observeSections(nodes) {
    var previous = {};
    sectionStates.forEach(function (state) { previous[state.id] = state; });
    if (observer) observer.disconnect();
    sectionStates.forEach(endVisibility);
    sectionStates = nodes.map(function (node, i) {
      var id = sectionId(node, i), old = previous[id] || {};
      var label = sectionLabel(node, id);
      node.setAttribute('data-cro-resolved-label', label || id);
      var state = { node: node, id: id, label: label, position: i + 1, visibleSince: 0, visibleMs: old.visibleMs || 0, maxPct: old.maxPct || 0, viewTimer: 0, reached: !!old.reached, viewed: !!old.viewed, engaged: !!old.engaged };
      if (sectionByElement) sectionByElement.set(node, state);
      return state;
    });
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = sectionByElement && sectionByElement.get(entry.target);
        if (!state) return;
        if (!eligible() || document.visibilityState !== 'visible') { endVisibility(state); return; }
        var reached = entry.isIntersecting && entry.intersectionRect.height >= Math.min(120, entry.boundingClientRect.height * 0.2);
        if (reached) markReached(state, 'viewport');
        var enough = entry.isIntersecting && entry.intersectionRect.height >= Math.min(entry.boundingClientRect.height * 0.5, innerHeight * 0.5);
        if (enough) beginVisibility(state, entry.intersectionRatio); else endVisibility(state);
      });
    }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
    sectionStates.forEach(function (state) { observer.observe(state.node); });
    markScrollDepth();
  }
  function explicitDataId(node) {
    var attrs = Array.prototype.slice.call(node.attributes || []).filter(function (a) {
      return /^data-(cro-element|ap-[a-z0-9-]+)$/.test(a.name) && a.value !== 'false';
    });
    if (!attrs.length) return '';
    var a = attrs[0];
    return clean(a.value || a.name.replace(/^data-/, ''));
  }
  function hrefIdentity(node) {
    var href = node.getAttribute && node.getAttribute('href');
    if (!href) return '';
    try {
      var p = new URL(href, location.origin).pathname;
      var product = p.match(/^\/products\/([^/?#]+)/);
      if (product) return 'product-' + clean(product[1]);
      var collection = p.match(/^\/collections\/([^/?#]+)/);
      if (collection) return 'collection-' + clean(collection[1]);
      return 'link-' + clean(p);
    } catch (_) { return ''; }
  }
  function elementId(node) {
    return clean(node.getAttribute('data-cro-element')) || explicitDataId(node) || hrefIdentity(node) ||
      clean(node.id) || clean(node.getAttribute('aria-label')) || clean(node.getAttribute('name')) ||
      clean(safeText(node.textContent)) || clean(node.tagName);
  }
  function elementRole(node) {
    if (node.matches('video')) return 'video';
    if (node.matches('[role="slider"],input[type="range"]')) return 'slider';
    if (node.matches('select,input[type="radio"],input[type="checkbox"]')) return 'choice';
    if (node.matches('input,textarea')) return 'field';
    if (node.matches('summary')) return 'disclosure';
    if (node.matches('a[href]')) return 'link';
    return node.getAttribute('role') || 'button';
  }
  function markElements() {
    if (!context || !context.root) return;
    Array.prototype.slice.call(context.root.querySelectorAll(INTERACTIVE_SELECTOR)).forEach(function (node) {
      if (!node || inGemPages(node) || node.hidden) return;
      var id = elementId(node), role = elementRole(node), sid = sectionFor(node);
      var label = safeText(node.getAttribute('aria-label') || node.textContent) || id;
      if (node.getAttribute('data-cro-resolved-element') === id &&
          node.getAttribute('data-cro-resolved-role') === role &&
          node.getAttribute('data-cro-resolved-section-id') === sid &&
          node.getAttribute('data-cro-resolved-label') === label) return;
      var rect = node.getBoundingClientRect();
      if (rect.width < 8 || rect.height < 8) return;
      node.setAttribute('data-cro-resolved-element', id);
      node.setAttribute('data-cro-resolved-role', role);
      node.setAttribute('data-cro-resolved-section-id', sid);
      node.setAttribute('data-cro-resolved-label', label);
    });
  }
  function trackInteraction(node, action) {
    if (!node || inGemPages(node)) return;
    var sectionNode = node.closest && node.closest('[data-cro-resolved-section]');
    var sectionState = sectionNode && sectionByElement && sectionByElement.get(sectionNode);
    if (sectionState) markReached(sectionState, 'interaction');
    var sid = sectionFor(node);
    if (sid === 'unassigned' && context.page_type !== 'collection') return;
    var href = node.getAttribute && node.getAttribute('href');
    var hrefPath = '';
    try { hrefPath = href ? new URL(href, location.origin).pathname.slice(0, 180) : ''; } catch (_) {}
    emit('cro_element_interacted', {
      section_id: sid,
      section_label: sectionLabelFor(node),
      section_position: sectionState ? sectionState.position : 0,
      element_id: elementId(node),
      element_role: elementRole(node),
      interaction: action,
      element_text: safeText(node.getAttribute('aria-label') || node.textContent),
      href_path: hrefPath
    }, node);
  }
  function wireInteractions() {
    document.addEventListener('click', function (event) {
      if (event.isTrusted === false) return;
      var node = event.target && event.target.closest && event.target.closest(INTERACTIVE_SELECTOR);
      if (node) trackInteraction(node, node.matches('summary') ? (node.parentElement && node.parentElement.open ? 'close' : 'open') : 'click');
    }, true);
    document.addEventListener('change', function (event) {
      if (event.isTrusted === false) return;
      var node = event.target && event.target.closest && event.target.closest('select,input:not([type="hidden"]),textarea');
      if (node) trackInteraction(node, 'change');
    }, true);
    document.addEventListener('focusin', function (event) {
      if (event.isTrusted === false) return;
      var node = event.target && event.target.closest && event.target.closest('input[type="search"],input[type="text"],input[type="email"],input[type="tel"],input[type="url"],textarea');
      if (!node || (focusedFields && focusedFields.has(node))) return;
      if (focusedFields) focusedFields.add(node);
      trackInteraction(node, 'focus');
    }, true);
    document.addEventListener('invalid', function (event) {
      if (event.isTrusted === false) return;
      var node = event.target;
      if (!node || inGemPages(node) || !node.closest || !node.closest('form')) return;
      emit('cro_form_error', { section_id: sectionFor(node), section_label: sectionLabelFor(node), element_id: clean(node.name || node.id || node.type || 'field'), error_type: 'invalid' });
    }, true);
    document.addEventListener('play', function (event) {
      if (event.isTrusted === false) return;
      if (event.target && event.target.matches && event.target.matches('video')) trackInteraction(event.target, 'play');
    }, true);
  }
  function refresh() {
    if (!eligible()) return;
    var nodes = discoverSections();
    if (!nodes.length) return;
    context.page_revision = structureRevision(nodes);
    var structure = nodes.map(function (node, i) { return sectionId(node, i); }).join('|');
    markElements();
    if (structure === observedStructure) return;
    observedStructure = structure;
    observeSections(nodes);
    if (!emittedPageView) {
      emittedPageView = true;
      emit('cro_page_viewed', { section_count: nodes.length, structure_hash: context.page_revision.split(':').pop() });
    }
  }
  var initialized = false;
  function init() {
    if (initialized || !eligible() || document.readyState === 'loading') return;
    initialized = true;
    pageViewId = window.__ap_visit || makeId();
    context = identifyContext();
    if (!context) return;
    window.__APCROObserverInstalled = true;
    wireInteractions();
    refresh();
    addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(markScrollDepth);
    }, { passive: true });
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (mutationTimer) return;
        mutationTimer = setTimeout(function () { mutationTimer = 0; refresh(); }, 1200);
      }).observe(context.root, { childList: true, subtree: true });
    }
    addEventListener('pagehide', function () { sectionStates.forEach(endVisibility); });
    addEventListener('load', flushGa4Events, { once: true });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        flushGa4Events();
        markScrollDepth();
      } else {
        sectionStates.forEach(endVisibility);
      }
    }, { passive: true });
    flushGa4Events();
  }
  if (window.apAnalyticsEligibility) window.apAnalyticsEligibility.subscribe(function(state){
    if (state.eligible) { if (initialized) refresh(); else init(); if (observer) sectionStates.forEach(function(s){ observer.observe(s.node); }); }
    else { pendingGa4Events = []; sectionStates.forEach(function(s){ clearTimeout(s.viewTimer); s.viewTimer = 0; s.visibleSince = 0; s.visibleMs = 0; s.maxPct = 0; s.reached = s.viewed = s.engaged = false; }); if (observer) observer.disconnect(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
